import(/* webpackMode: "eager" */ "/vercel/path0/src/app/contact/page.tsx");
